<template src="./socialAll.pug" lang="pug"></template>
<script>
import { mapGetters } from 'vuex'

import Trip from './trip'
import GoogleMB from './google'

  export default{
    components: {
      Trip,
      GoogleMB
    },
    data(){
      return{
        tab: null
      }
    },
    methods: {
      ...mapGetters(['isTokenSet'])
    }
  }
</script>
